<template>
  <div class="card">
    <div class="row no-gutters">
      <div
        @click="$emit('deleteCard', caseStudy)"
        class="col-md-4 image-wrapper"
      >
        <img :src="caseStudy.image" class="card-img" alt="" />
        <div class="img-mask">
          <svg width="52pt" height="52pt" viewBox="0 0 52 52">
            <path
              d="M 23 -0.0625 C 19.085938 -0.0625 15.9375 3.1875 15.9375 7.125 L 15.9375 8 L 8 8 C 6.898438 8 6 8.898438 6 10 L 6 12 L 4 12 L 4 16 L 8 16 L 8 46 C 8 49.289063 10.710938 52 14 52 L 38 52 C 41.289063 52 44 49.289063 44 46 L 44 16 L 48 16 L 48 12 L 46 12 L 46 10 C 46 8.898438 45.101563 8 44 8 L 36.0625 8 L 36.0625 7.125 C 36.0625 3.1875 32.914063 -0.0625 29 -0.0625 Z M 23 4.0625 L 29 4.0625 C 30.609375 4.0625 31.9375 5.375 31.9375 7.125 L 31.9375 8 L 20.0625 8 L 20.0625 7.125 C 20.0625 5.375 21.390625 4.0625 23 4.0625 Z M 12 16 L 22.25 16 C 22.5 16.023438 22.742188 16.0625 23 16.0625 L 29 16.0625 C 29.257813 16.0625 29.5 16.023438 29.75 16 L 40 16 L 40 46 C 40 47.125 39.125 48 38 48 L 14 48 C 12.875 48 12 47.125 12 46 Z M 16 20 L 16 44 L 20 44 L 20 20 Z M 24 20 L 24 44 L 28 44 L 28 20 Z M 32 20 L 32 44 L 36 44 L 36 20 Z "
            />
          </svg>
        </div>
      </div>
      <div class="col-md-8">
        <div
          class="card-body"
          :class="{
            active: marked
          }"
        >
          <input
            type="text"
            v-model.trim="name"
            class="card-text"
            @keypress.enter="sendNewName"
          />
          <input
            type="text"
            v-model.trim="image"
            class="card-text"
            @keypress.enter="sendNewName"
          />
          <p class="card-text">
            <small class="text-muted"
              >Last updated {{ caseStudy.createdOn.seconds | date }}</small
            >
          </p>
          <div class="card-actions">
            <p class="mark-delete" @click="$emit('addToBulkDelete', image)">
              {{ marked ? "MARKED FOR DELETE" : "MARK FOR DELETE" }}
            </p>
            <p class="edit" @click="sendNewName" :class="{ editable: name }">
              EDIT
            </p>
            <router-link :to="{ name: 'Case Study', params: { slug: slug } }">
              GO TO CASE STUDY
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    caseStudy: {
      type: Object
    },
    marked: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      name: this.caseStudy.name,
      image: this.caseStudy.image
    };
  },
  computed: {
    slug() {
      return this.caseStudy.name.toLowerCase().replace(" ", "-");
    }
  },
  methods: {
    sendNewName() {
      const updatedCaseStudy = {
        image: this.image,
        name: this.name ? this.name : this.caseStudy.name,
        id: this.caseStudy.id
      };
      let confirm = window.confirm(
        "Are you sure you want to change " +
          this.caseStudy.name +
          " to " +
          updatedCaseStudy.name
      );
      if (confirm) {
        this.$emit("updateName", updatedCaseStudy);
      }
    }
  },
  filters: {
    date(value) {
      if (!value) return "";
      return new Date(value * 1000).toString().split("GMT")[0];
    }
  }
};
</script>

<style lang="scss" scoped>
.card {
  background: black;
  animation: slide-up 0.8s ease forwards;

  @keyframes slide-up {
    from {
      transform: translateY(100%);
    }
  }

  .card-body {
    height: 100%;

    input {
      background: none;
      border: none;
      color: rgba(white, 0.5);
      width: 100%;

      &::placeholder {
        opacity: 1;
      }

      &::selection {
        background-color: $primary;
      }
    }

    &.active {
      background: rgba($primary, 0.3);
    }

    .card-actions {
      font-size: 0.8rem;
      font-weight: 700;
      cursor: pointer;
      display: flex;
      justify-content: space-between;

      .mark-delete {
        color: $primary;
      }

      .editable {
        color: green;
      }
    }
  }

  .image-wrapper {
    position: relative;
    overflow: hidden;
    cursor: pointer;

    .card-img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      position: absolute;
    }

    .img-mask {
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      width: 100%;
      background-color: brown;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: 0.3s all ease;
      transform: translateX(100%);

      svg {
        fill: #f5f5f5;
        height: 30%;
      }
    }

    &:hover {
      .img-mask {
        transform: translateX(0);
      }
    }
  }
}
</style>
